import { IoIosCloseCircleOutline } from "react-icons/io";
import constant from "../../../../../constants/constant";
import atoms from "../../../../atoms";
import { ProductData, RenderActionProps, RenderCostAmount, RenderDiscountAmount, RenderDiscountPercentage, TInventoryTable } from "../interface";

const { Input } = atoms

export const useTable = () => {
  // Cost Amount
  const renderCostAmount = ({ item, handleCalculation }: RenderCostAmount) => {
    return (
      <Input
        value={item?.additional_keys?.cost_amount}
        className="custom-input-height fs-12"
        type="number"
        onChange={(e: any) =>
          handleCalculation("cost_amount", e.target.value)
        }
      />
    );
  };

  // GST in Percentage
  // const renderGSTPercentage = ({ item, handleCalculation }: RenderGSTPercentage) => {
  //   return (
  //     <Input
  //       value={item?.additional_keys?.gst_percentage}
  //       className="custom-input-height fs-12"
  //       type="number"
  //       onChange={(e: any) =>
  //         handleCalculation("gst_percentage", e.target.value)
  //       }
  //     />
  //   );
  // };

  // Discount in Percentage
  const renderDiscountPercentage = ({ item, handleCalculation }: RenderDiscountPercentage) => {
    return (
      <Input
        value={item?.additional_keys?.discount_percentage}
        className="custom-input-height fs-12"
        type="number"
        onChange={(e: any) =>
          handleCalculation("discount_percentage", e.target.value)
        }
      />
    );
  };

  // Discount in Amount
  const renderDiscountAmount = ({ item, handleCalculation }: RenderDiscountAmount) => {
    return (
      <Input
        value={item?.additional_keys?.discount_amount}
        className="custom-input-height fs-12"
        type="number"
        onChange={(e: any) =>
          handleCalculation("discount_amount", e.target.value)
        }
      />
    );

  };

  // Quantity of product
  const renderQty = ({ item, handleCalculation }: RenderDiscountAmount) => {
    return (
      <Input
        value={item?.additional_keys?.qty}
        className="custom-input-height fs-12"
        type="number"
        onChange={(e: any) =>
          handleCalculation("qty", e.target.value)
        }
      />
    );
  }

  //isActive Status
  const renderStatus = (item: ProductData) => {
    return (
      <div
        className={`${item.isActive
          ? "background-light-green"
          : "background-light-red"
          } border-product-radius`}
      >
        <div
          className={`${item.isActive ? "color-green" : "color-red"
            } fw-600  m-1 p-1`}
        >
          {item.isActive
            ? constant.STATUS.ACTIVE
            : constant.STATUS.DEACTIVE}
        </div>
      </div>
    )
  }

  //verification status
  const renderVerificationStatus = (item: ProductData) => {
    return item.verification_status ===
      constant.VERIFICATION_STATUS.PENDING ? (
      <div className="background-light-yellow border-product-radius">
        <p className="color-yellow m-1 p-1">{"Pending"}</p>
      </div>
    ) : item.verification_status ===
      constant.VERIFICATION_STATUS.VERIFIED ? (
      <div className="background-light-green border-product-radius">
        <p className="color-green m-1 p-1">{"Verified"}</p>
      </div>
    ) : item.verification_status ===
      constant.VERIFICATION_STATUS.REWORK ? (
      <div className="background-light-red border-product-radius">
        <p className="color-red m-1 p-1">{"Rework"}</p>
      </div>
    ) : (
      ""
    )
  };

  // Action button
  const renderAction = ({ handleRemoveProduct, item }: RenderActionProps) => {
    return <div className="d-flex align-items-center">
      <IoIosCloseCircleOutline
        className="fs-24"
        onClick={() =>
          handleRemoveProduct(item.custom_index, item)
        }
      />
    </div>
  }

  //Last Row of Table
  const getTotalRow = (data: TInventoryTable[]): TInventoryTable[] => {
    let subtotal = 0;
    let gst = 0;
    let grandTotal = 0;
    let qty = 0;
    let withCase = 0;
  
    data.forEach(item => {
      subtotal += item?.additional_keys?.subtotal_amount ?? 0;
      gst += item?.additional_keys?.gst_amount ?? 0;
      grandTotal += item?.additional_keys?.grand_total_amount ?? 0;
      qty +=  item?.additional_keys?.qty;
      withCase += item?.product_with_case ? 1 : 0
    });
  
    const summaryRow: TInventoryTable = {
      ...data[0],
      id: "summary-row",
      last_row:true,
      additional_keys: {
        cost_amount: NaN,
        discount_amount: NaN,
        discount_percentage: NaN,
        qty: qty,
        subtotal_amount: subtotal,
        gst_amount: gst,
        grand_total_amount: grandTotal,
        total_product_with_case:withCase
      },
    };
  
    return [...data, summaryRow];
  };
  




  return {
    renderCostAmount,
    renderDiscountPercentage,
    renderDiscountAmount,
    renderQty,
    renderStatus,
    renderVerificationStatus,
    renderAction,
    getTotalRow
  };
};
